import { SeriesModel, SeriesAccessModel } from "@api/models";
import EpisodeListItem from "./EpisodeListItem";
import { getWaitAndFreeWaiting, seriesAccessToepisodeAccessSet } from "@lib/utils";
import { SeriesEpisodeListLoader } from "./SeriesEpisodeListLoader";
import { EpisodeDisplayedOn } from "../../../types/types";

export function SeriesEpisodeList({
  seriesWithFirstEps,
  seriesWithLastEps,
  seriesAccess,
  seriesStartIndex,
  sort,
  currentEpisodeId,
  displayedOn,
}: {
  seriesWithFirstEps: SeriesModel | undefined;
  seriesWithLastEps: SeriesModel | undefined;
  seriesAccess: SeriesAccessModel | undefined;
  seriesStartIndex?: number;
  sort?: "new" | "old";
  currentEpisodeId?: string;
  displayedOn: EpisodeDisplayedOn;
}) {
  if (!seriesWithFirstEps) {
    return <></>;
  }
  if (!seriesStartIndex) {
    seriesStartIndex = 1;
  }
  const epCount = seriesWithFirstEps.summary.numEpisodes;
  const lastEpIndex = seriesWithLastEps ? epCount - seriesWithLastEps.episodes.length : epCount;
  const waitAndFreeWaiting = getWaitAndFreeWaiting(seriesWithFirstEps.summary.seriesWaitOn);

  const episodeAccessSet = seriesAccessToepisodeAccessSet(seriesAccess);
  if (sort === "old") {
    return (
      <>
        {seriesWithFirstEps &&
          seriesWithFirstEps.episodes.map((episode, index) => {
            return (
              <EpisodeListItem
                episode={episode}
                key={episode.id}
                waitAndFreeWaiting={waitAndFreeWaiting}
                access={episodeAccessSet.getEpisodeAccessByEpisodeId(episode.id)}
                currentEpisodeId={currentEpisodeId}
                displayIndex={index}
                displayedOn={displayedOn}
              />
            );
          })}
        <SeriesEpisodeListLoader
          seriesWaitOn={seriesWithFirstEps.summary.seriesWaitOn}
          seriesHash={seriesWithFirstEps.summary.id}
          start={seriesStartIndex + seriesWithFirstEps.episodes.length}
          end={lastEpIndex}
          sort={sort}
          displayedOn={displayedOn}
        />
        {seriesWithLastEps &&
          seriesWithLastEps.episodes.map((episode, index) => {
            return (
              <EpisodeListItem
                episode={episode}
                key={episode.id}
                waitAndFreeWaiting={waitAndFreeWaiting}
                access={episodeAccessSet.getEpisodeAccessByEpisodeId(episode.id)}
                currentEpisodeId={currentEpisodeId}
                displayIndex={index}
                displayedOn={displayedOn}
              />
            );
          })}
      </>
    );
  } else {
    return (
      <>
        {seriesWithLastEps &&
          seriesWithLastEps.episodes.map((_, index) => {
            const episode =
              seriesWithLastEps.episodes[seriesWithLastEps.episodes.length - 1 - index];
            return (
              <EpisodeListItem
                episode={episode}
                key={episode.id}
                waitAndFreeWaiting={waitAndFreeWaiting}
                access={episodeAccessSet.getEpisodeAccessByEpisodeId(episode.id)}
                currentEpisodeId={currentEpisodeId}
                displayIndex={index}
                displayedOn={displayedOn}
              />
            );
          })}
        <SeriesEpisodeListLoader
          seriesWaitOn={seriesWithFirstEps.summary.seriesWaitOn}
          seriesHash={seriesWithFirstEps.summary.id}
          start={seriesStartIndex + seriesWithFirstEps.episodes.length}
          end={lastEpIndex}
          sort={sort}
          displayedOn={displayedOn}
        />
        {seriesWithFirstEps &&
          seriesWithFirstEps.episodes.map((_, index) => {
            const episode =
              seriesWithFirstEps.episodes[seriesWithFirstEps.episodes.length - 1 - index];
            return (
              <EpisodeListItem
                episode={episode}
                key={episode.id}
                waitAndFreeWaiting={waitAndFreeWaiting}
                access={episodeAccessSet.getEpisodeAccessByEpisodeId(episode.id)}
                currentEpisodeId={currentEpisodeId}
                displayIndex={index}
                displayedOn={displayedOn}
              />
            );
          })}
      </>
    );
  }
}
